/* eslint-disable object-curly-newline,no-undef */
import PropTypes from 'prop-types';
import React from 'react';
import {Alert, Checkbox, Col, FormGroup, Grid, Panel, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Field, Form, propTypes, reduxForm} from 'redux-form';
import {BASE_URL} from '../../helpers/api/apiPaths';
import {role} from '../../reducers/currentUser/currentUser.reducer';
import {isLocal} from '../../reducers/localId/localId';
import {load as loadProjects} from '../../reducers/projects/projects.actions';
import {activeProjects} from '../../reducers/projects/projects.reducer';
import {apiSaveDirty as saveEmployeeTimesheets} from '../../reducers/workOrder/employeeTimesheets/employeeTimesheets.actions';
import {apiSaveDirty as saveEquipmentTimesheets} from '../../reducers/workOrder/equipmentTimesheets/equipmentTimesheets.actions';
import {apiSaveDirty as saveMaterials} from '../../reducers/workOrder/material/material.actions';
import {apiSaveDirty as saveSubContractorTimesheets} from '../../reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.actions';
import {
  load,
  newWorkOrder as newWorkOrderReducer,
  pdf,
  redirectToNew,
  remove, resendApprovedEmail,
  save,
  setNoTailgate, tailgatePdf,
  unsetNewId,
} from '../../reducers/workOrder/workOrders.actions';
import {
  dirty,
  loading,
  newId,
  noTailgate,
  redirect,
  tailgateError,
  workOrder,
} from '../../reducers/workOrder/workOrders.reducer';
import {ErrorAlert} from '../ErrorAlert/ErrorAlert';
import DateFormGroup from '../Forms/DateFormGroup/DateFormGroup';
import FileInput from '../Forms/FileInput/FileInput';
import SelectFormGroup from '../Forms/SelectFormGroup/SelectFormGroup';
import TTFormGroup from '../Forms/TTFormGroup/TTFormGroup';
import S3Item from '../S3Item/S3Item';
import {Spinner} from '../Spinner/Spinner';
import SpinnerButton from '../SpinnerButton/SpinnerButton';
import ConnectedWorkOrderEmployees from './Employees/EmployeeTimesheets';
import ConnectedEquipmentTimesheets from './EquipmentTimesheets/EquipmentTimesheets';
import ConnectedMaterials from './Materials/Materials';
import ConnectedWorkOrderSubContractorTimesheets from './SubContractorTimesheets/SubContractorTimesheets';
import './WorkOrder.css';
import CategorySelectFormGroup from '../Forms/CategorySelectFormGroup/CategorySelectFormGroup';
import {ViewOnlyWorkOrder} from "./ViewOnly/ViewOnlyWorkOrder";

export const requiredValue = value => (value ? undefined : 'Required');

// eslint-disable-next-line react/prefer-stateless-function
export class WorkOrder extends React.Component {
  componentWillMount() {
    this.props.unsetNewId();
  }

  componentDidMount() {
    console.log("action", this.props.match.params.action);
    if (this.props.match.params.id !== 'new') {
      this.props.load(this.props.match.params.id);
    } else {
      this.props.newWorkOrder();
    }

    this.props.loadProjects();
  }

  componentWillReceiveProps(nextProps) {
    const newIdProp = nextProps.match.params.id;
    if (this.props.match.params.id !== newIdProp && newIdProp !== 'new') {
      this.props.load(newIdProp);
      this.props.unsetNewId();
    }
  }

  render() {
    let {initialValues} = this.props;
    initialValues = initialValues || {};
    const submitted = initialValues.status === 'submitted';
    const approved = initialValues.status === 'approved';
    if (this.props.newId && this.props.redirect) {
      (document.location = this.props.match.url.replace('new', this.props.newId));
    }
    const disabled = (approved && ['foreman', 'pm'].includes(role()));
    const approveButtonDisabled = (submitted && role() === 'foreman');

    return (
      <span>
        <Spinner isLoading={this.props.loading}/>
        <Grid fluid>
          {(approved || submitted) &&
          <Row>
            <Col sm={4} smOffset={8}>
              <SpinnerButton onClick={() => pdf(initialValues.project.name, initialValues.wo_date, initialValues.id)}>
                Download PDF
              </SpinnerButton>
            </Col>
            <Col sm={4} smOffset={8}>
              <SpinnerButton onClick={() => pdf(initialValues.project.name, initialValues.wo_date, initialValues.id, "materials/pdf")}>
                Materials PDF
              </SpinnerButton>
            </Col>
            <Col sm={4} smOffset={8}>
              <SpinnerButton
                onClick={() => tailgatePdf(initialValues.project.name, initialValues.wo_date, initialValues.id)}>
                Tailgate PDF
              </SpinnerButton>
            </Col>
            {approved &&
            <Col sm={4} smOffset={8}>
              <SpinnerButton onClick={() => resendApprovedEmail(initialValues.id)}>
                Re-send Approved Email
              </SpinnerButton>
            </Col>
            }
          </Row>}
          {
            this.props.match.params.action === 'view'
              ? <ViewOnlyWorkOrder workOrder={this.props.initialValues}/>
              : <span>
          <Form onSubmit={() => ({})}>
            {submitted &&
            <Row>
              <Col><Alert bsStyle="info">This DWR has been submitted to the PM</Alert></Col>
            </Row>
            }
            {approved &&
            <Row>
              <Col><Alert bsStyle="info">This DWR has been approved</Alert></Col>
            </Row>
            }


            <Row>
              <Col sm={4}>
                <Field
                  component={DateFormGroup}
                  name="wo_date"
                  label="Date"
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
              <Col sm={4}>
                <Field
                  component={CategorySelectFormGroup}
                  name="project_id"
                  label="Project"
                  options={this.props.projects}
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
              <Col sm={4}>
                <Field
                  component={TTFormGroup}
                  name="inspector"
                  label="Inspector"
                  type="text"
                  required
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={3}>
                <Field
                  component={TTFormGroup}
                  name="city"
                  label="City"
                  type="text"
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={SelectFormGroup}
                  name="state"
                  label="State"
                  options={[
                    {id: 'IA', name: 'IA'},
                    {id: 'MN', name: 'MN'},
                    {id: 'NE', name: 'NE'},
                    {id: 'WI', name: 'WI'},
                    {id: '', name: '----'},
                    {id: 'AK', name: 'AK'},
                    {id: 'AL', name: 'AL'},
                    {id: 'AR', name: 'AR'},
                    {id: 'AZ', name: 'AZ'},
                    {id: 'CA', name: 'CA'},
                    {id: 'CO', name: 'CO'},
                    {id: 'CT', name: 'CT'},
                    {id: 'DE', name: 'DE'},
                    {id: 'FL', name: 'FL'},
                    {id: 'GA', name: 'GA'},
                    {id: 'HI', name: 'HI'},
                    {id: 'IA', name: 'IA'},
                    {id: 'ID', name: 'ID'},
                    {id: 'IL', name: 'IL'},
                    {id: 'IN', name: 'IN'},
                    {id: 'KS', name: 'KS'},
                    {id: 'KY', name: 'KY'},
                    {id: 'LA', name: 'LA'},
                    {id: 'MA', name: 'MA'},
                    {id: 'MD', name: 'MD'},
                    {id: 'ME', name: 'ME'},
                    {id: 'MI', name: 'MI'},
                    {id: 'MN', name: 'MN'},
                    {id: 'MO', name: 'MO'},
                    {id: 'MS', name: 'MS'},
                    {id: 'MT', name: 'MT'},
                    {id: 'NC', name: 'NC'},
                    {id: 'ND', name: 'ND'},
                    {id: 'NE', name: 'NE'},
                    {id: 'NH', name: 'NH'},
                    {id: 'NJ', name: 'NJ'},
                    {id: 'NM', name: 'NM'},
                    {id: 'NV', name: 'NV'},
                    {id: 'NY', name: 'NY'},
                    {id: 'OH', name: 'OH'},
                    {id: 'OK', name: 'OK'},
                    {id: 'OR', name: 'OR'},
                    {id: 'PA', name: 'PA'},
                    {id: 'RI', name: 'RI'},
                    {id: 'SC', name: 'SC'},
                    {id: 'SD', name: 'SD'},
                    {id: 'TN', name: 'TN'},
                    {id: 'TX', name: 'TX'},
                    {id: 'UT', name: 'UT'},
                    {id: 'VA', name: 'VA'},
                    {id: 'VT', name: 'VT'},
                    {id: 'WA', name: 'WA'},
                    {id: 'WI', name: 'WI'},
                    {id: 'WV', name: 'WV'},
                    {id: 'WY', name: 'WY'},
                  ]}
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={TTFormGroup}
                  name="zip"
                  label="Zip"
                  type="text"
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={TTFormGroup}
                  name="county"
                  label="County"
                  type="text"
                  required
                  disabled={disabled}
                  validate={requiredValue}
                />
              </Col>
            </Row>
            <Row>
              <Panel header="Work Accomplished">
                <Field
                  component={TTFormGroup}
                  componentClass="textarea"
                  name="work_accomplished"
                  disabled={disabled}
                />
              </Panel>
            </Row>
            <Row>
              <Panel header="Notes">
                <Field
                  component={TTFormGroup}
                  componentClass="textarea"
                  name="notes"
                  disabled={disabled}
                />
              </Panel>
            </Row>
            <Row>
              <Panel header="Job Safety Environmental Analysis ( JSEA )">
                <Field component={TTFormGroup} type="hidden" name="tailgate_url" value={initialValues.tailgate_url}/>
                {this.props.tailgateError &&
                <Row>
                  <Col xs={12}>
                    <ErrorAlert>{this.props.tailgateError}</ErrorAlert>
                  </Col>
                </Row>
                }
                {!initialValues.tailgate_url &&
                <Row>
                  <Col>
                    <FormGroup>
                      <Checkbox
                        className="big-checkbox"
                        onChange={this.props.setNone(initialValues.id)}
                        checked={this.props.noTailgate}
                      >
                        No JSEA.
                      </Checkbox>
                    </FormGroup>
                  </Col>
                </Row>
                }
                {this.props.noTailgate &&
                <span>
                  <Field
                    component={TTFormGroup}
                    componentClass="textarea"
                    name="tailgate_daily_activity"
                    label="Daily Activity"
                    disabled={disabled}
                  />
                  <Field
                    component={TTFormGroup}
                    componentClass="textarea"
                    name="tailgate_safety_hazards"
                    label="Safety Hazards"
                    disabled={disabled}
                  />
                </span>
                }
                {(!this.props.noTailgate) &&
                <Row>
                  <Col>
                    <Field
                      component={FileInput}
                      name="tailgate"
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                }
                {initialValues.tailgate_url &&
                <Row>
                  <Col>
                    <S3Item
                      isPdf={initialValues.tailgate_is_pdf}
                      link={`${BASE_URL}/workorders/${initialValues.id}/tailgate`}
                    />
                  </Col>
                </Row>
                }
              </Panel>
            </Row>
          </Form>
          <Row>
            <ConnectedWorkOrderEmployees
              workOrderId={this.props.match.params.id}
              saveWorkOrder={this.props.handleSubmit(v => this.props.save(v, false))}
              disabled={disabled}
            />
          </Row>
          <Row>
            <ConnectedWorkOrderSubContractorTimesheets
              workOrderId={this.props.match.params.id}
              saveWorkOrder={this.props.handleSubmit(v => this.props.save(v, false))}
              disabled={disabled}
            />
          </Row>
          <Row>
            <ConnectedEquipmentTimesheets
              workOrderId={this.props.match.params.id}
              saveWorkOrder={this.props.handleSubmit(v => this.props.save(v, false))}
              disabled={disabled}
            />
          </Row>
          <Row>
            <ConnectedMaterials
              workOrderId={this.props.match.params.id}
              saveWorkOrder={this.props.handleSubmit(v => this.props.save(v, false))}
              disabled={disabled}
            />
          </Row>
          </span>
          }

          {submitted &&
          <Row>
            <Col><Alert bsStyle="info">This DWR has been submitted to the PM</Alert></Col>
          </Row>
          }
          {approved &&
          <Row>
            <Col><Alert bsStyle="info">This DWR has been approved</Alert></Col>
          </Row>
          }

          <Row>
            <Row>
              <Col xs={12} sm={3}>
                <SpinnerButton
                  isLoading={this.props.loading}
                  dirty={this.props.workOrderDirty}
                  onClick={this.props.handleSubmit(v => this.props.save(v, false))}
                  disabled={disabled}
                >
                  Save
                </SpinnerButton>
              </Col>
              {!approved &&
              <Col xs={12} md={3}>
                <SpinnerButton
                  isLoading={this.props.loading}
                  dirty={!this.props.workOrderDirty}
                  onClick={this.props.handleSubmit(v => this.props.save(v, true, approveButtonDisabled))}
                  disabled={disabled || approveButtonDisabled}
                >
                  {submitted ? 'Approve' : 'Submit'}
                </SpinnerButton>
              </Col>
              }
              <Col xs={12} md={3}>
                <SpinnerButton
                  bsStyle="danger"
                  onClick={() => {
                    if (window.confirm('Are you sure you want to delete?')) {
                      this.props.remove(this.props.match.params.id);
                    }
                  }}
                  disabled={disabled}
                >
                  Delete DWR
                </SpinnerButton>
              </Col>
            </Row>
          </Row>
        </Grid>
      </span>
    );
  }
}

WorkOrder.defaultProps = {
  noTailgate: false,
};

WorkOrder.propTypes = {
  ...propTypes,
  load: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  loadProjects: PropTypes.func.isRequired,
  newWorkOrder: PropTypes.func.isRequired,
  setNone: PropTypes.func.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  workOrderDirty: PropTypes.bool.isRequired,
  noTailgate: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export const mapStateToProps = (state, {match: {params: {id}}}) => ({
  initialValues: (isLocal(id)) ? {id} : workOrder(state, id),
  noTailgate: noTailgate(state, id),
  tailgateError: tailgateError(state, id),
  form: `workOrder${id}`,
  projects: activeProjects(state),
  loading: loading(state),
  newId: newId(state),
  redirect: redirect(state),
  workOrderDirty: dirty(state, id),
});

export const mapDispatchToProps = dispatch => ({
  load: id => dispatch(load(id)),
  loadProjects: () => dispatch(loadProjects()),
  save: (values, submit, canApprove = false) => {
    dispatch(save(values, submit, canApprove))
      .then(() => Promise.all(
        [dispatch(saveEmployeeTimesheets()), dispatch(saveEquipmentTimesheets()), dispatch(saveMaterials()), dispatch(saveSubContractorTimesheets())],
      ).then(() => dispatch(redirectToNew())));
  },
  unsetNewId: () => dispatch(unsetNewId()),
  newWorkOrder: () => dispatch(newWorkOrderReducer()),
  remove: id => dispatch(remove(id)).then(() => {
    document.location = '/';
  }),
  setNone: workOrderId => e => dispatch(setNoTailgate(workOrderId, e.target.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({enableReinitialize: true})(WorkOrder));



// WEBPACK FOOTER //
// ./src/components/WorkOrder/WorkOrder.jsx